import React, { useRef } from "react";

export default function VerificationCodeInput({
  length = 6,
  value,
  onChange,
  isError,
}) {
  const inputs = useRef([]);

  const handleChange = (e, index) => {
    const val = e.target.value;

    if (!/^\d?$/.test(val)) return;

    const newValue = value.split("");
    newValue[index] = val;
    onChange(newValue.join(""));

    if (val && index < length - 1) {
      inputs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !value[index] && index > 0) {
      inputs.current[index - 1]?.focus();
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "8px",
      }}
    >
      {Array.from({ length }).map((_, index) => (
        <input
          key={index}
          ref={(el) => (inputs.current[index] = el)}
          type="password"
          inputMode="numeric"
          maxLength={1}
          value={value[index] || ""}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          style={{
            width: "42px",
            height: "42px",
            textAlign: "center",
            fontSize: "18px",
            borderRadius: "6px",
            border: isError ? "2px solid #dc3545" : "1px solid #ccc",
            backgroundColor: "rgba(39, 39, 39, 85%)",
            color: "white",
          }}
        />
      ))}
    </div>
  );
}
